module.exports = __webpack_public_path__ + "static/img/non-retail.ff92c89c.svg";